import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { Button } from "@mui/material";
import AppDialogDefault from "@/components/ui/appDialogDefault/AppDialogDefault.component";
import type { ResumoAlteracoes } from "./restricoes.utils";
import ResumoAlteracoesPainel from "./ResumoAlteracoesPainel";

type DialogConfirmarDescarteProps = {
	readonly aberto: boolean;
	readonly grupoNome: string;
	readonly resumo: ResumoAlteracoes;
	readonly acoes: {
		readonly onFechar: () => void;
		readonly onConfirmar: () => void;
	};
};

export default function DialogConfirmarDescarte({ aberto, grupoNome, resumo, acoes }: DialogConfirmarDescarteProps) {
	const subtitulo =
		resumo.total === 1
			? "1 alteração não salva será descartada"
			: `${resumo.total} alterações não salvas serão descartadas`;

	return (
		<AppDialogDefault
			aberto={aberto}
			onFechar={acoes.onFechar}
			titulo={`Descartar alterações · ${grupoNome}`}
			subtitulo={subtitulo}
			icone="lucide:rotate-ccw"
			maxWidth="sm"
			exibirBotaoFecharRodape={false}
			impedirFecharBackdrop
			bodyClassName="overflow-hidden"
			actionsClassName="shrink-0 gap-2 px-6 pb-4"
			acoesRodape={
				<>
					<Button
						variant="outlined"
						color="secondary"
						size="small"
						onClick={acoes.onFechar}
						startIcon={<FuseSvgIcon size={16}>lucide:x</FuseSvgIcon>}
					>
						Cancelar
					</Button>
					<Button
						variant="contained"
						color="error"
						size="small"
						onClick={acoes.onConfirmar}
						disabled={resumo.total === 0}
						startIcon={<FuseSvgIcon size={16}>lucide:rotate-ccw</FuseSvgIcon>}
					>
						Descartar
					</Button>
				</>
			}
		>
			<ResumoAlteracoesPainel resumo={resumo} />
		</AppDialogDefault>
	);
}
